module.exports = __webpack_public_path__ + "img/sina.c1cd25a3.png";